const PlatformsEnum = {
  PC: "pc",
  NINTENDO_GAMECUBE: "nintendo-gamecube",
  NINTENDO_64: "nintendo-64",
  NINTENDO_GAMEBOY: "nintendo-gameboy",
  NINTENDO_GAMEBOY_ADVANCE: "nintendo-gameboy-advance",
  SUPER_NINTENDO_SNES: "super-nintendo-snes",
  NINTENDO_ENTERTAINMENT_SYSTEM_NES: "nintendo-entertainment-system-nes",
  NINTENDO_DS: "nintendo-ds",
  NINTENDO_WII: "nintendo-wii",
  SONY_PLAYSTATION: "sony-playstation",
  SONY_PLAYSTATION_2: "sony-playstation-2",
  SONY_PLAYSTATION_3: "sony-playstation-3",
  SONY_PSP: "sony-psp",
  MICROSOFT_XBOX: "microsoft-xbox",
  MICROSOFT_XBOX_360: "microsoft-xbox-360",
  SEGA_DREAMCAST: "sega-dreamcast",
  SEGA_SATURN: "sega-saturn",
  SEGA_GENESIS: "sega-genesis",
  SEGA_GAME_GEAR: "sega-game-gear",
  SEGA_CD: "sega-cd",
  ATARI_2600: "atari-2600",
  ARCADE: "arcade",
  NEOGEO: "neogeo",
  THREE_DO: "3do",
  ATARI_5200: "atari-5200",
  ATARI_7800: "atari-7800",
  ATARI_JAGUAR: "atari-jaguar",
  ATARI_JAGUAR_CD: "atari-jaguar-cd",
  ATARI_XE: "atari-xe",
  COLECOVISION: "colecovision",
  INTELLIVISION: "intellivision",
  SEGA_32X: "sega-32x",
  TURBOGRAFX_16: "turbografx-16",
  SEGA_MASTER_SYSTEM: "sega-master-system",
  SEGA_MEGA_DRIVE: "sega-mega-drive",
  MAC_OS: "mac-os",
  NINTENDO_WII_U: "nintendo-wii-u",
  SONY_PLAYSTATION_VITA: "sony-playstation-vita",
  COMMODORE_64: "commodore-64",
  NINTENDO_GAMEBOY_COLOR: "nintendo-gameboy-color",
  AMIGA: "amiga",
  NINTENDO_3DS: "nintendo-3ds",
  SINCLAIR_ZX_SPECTRUM: "sinclair-zx-spectrum",
  AMSTRAD_CPC: "amstrad-cpc",
  IOS: "ios",
  ANDROID: "android",
  PHILIPS_CD_I: "philips-cd-i",
  NINTENDO_VIRTUAL_BOY: "nintendo-virtual-boy",
  SONY_PLAYSTATION_4: "sony-playstation-4",
  MICROSOFT_XBOX_ONE: "microsoft-xbox-one",
  OUYA: "ouya",
  NEO_GEO_POCKET: "neo-geo-pocket",
  NEO_GEO_POCKET_COLOR: "neo-geo-pocket-color",
  ATARI_LYNX: "atari-lynx",
  WONDERSWAN: "wonderswan",
  WONDERSWAN_COLOR: "wonderswan-color",
  MAGNAVOX_ODYSSEY_2: "magnavox-odyssey-2",
  FAIRCHILD: "fairchild",
  MSX: "msx",
  PC_FX: "pcfx",
  SHARP_X68000: "x68",
  FM_TOWNS_MARTY: "fmtowns",
  PC_88: "pc88",
  PC_98: "pc98",
  NUON: "nuon",
  FAMICOM_DISK_SYSTEM: "fds",
  ATARI_ST: "atari-st",
  N_GAGE: "ngage",
  VECTREX: "vectrex",
  GAME_COM: "game-com",
  TRS_80_COLOR: "trs80-color",
  APPLE_II: "apple2",
  ATARI_800: "atari800",
  ACORN_ARCHIMEDES: "acorn-archimedes",
  COMMODORE_VIC20: "commodore-vic20",
  COMMODORE_128: "c128",
  AMIGA_CD32: "amiga-cd32",
  MEGA_DUCK: "megaduck",
  SEGA_SG_1000: "sg1000",
  GAME_AND_WATCH: "game-and-watch",
  HANDHELD_ELECTRONIC_GAMES_LCD: "lcd",
  DRAGON32_64: "dragon32-64",
  TEXAS_INSTRUMENTS_TI_99_4A: "texas-instruments-ti-99-4a",
  ACORN_ELECTRON: "acorn-electron",
  TURBO_GRAFX_CD: "turbo-grafx-cd",
  NEO_GEO_CD: "neo-geo-cd",
  NINTENDO_POKMON_MINI: "nintendo-pokmon-mini",
  SEGA_PICO: "sega-pico",
  WATARA_SUPERVISION: "watara-supervision",
  TOMY_PYTA: "tomy-pyta",
  MAGNAVOX_ODYSSEY: "magnavox-odyssey",
  GAKKEN_COMPACT_VISION: "gakken-compact-vision",
  EMERSON_ARCADIA_2001: "emerson-arcadia-2001",
  CASIO_PV_1000: "casio-pv-1000",
  EPOCH_CASSETTE_VISION: "epoch-cassette-vision",
  EPOCH_SUPER_CASSETTE_VISION: "epoch-super-cassette-vision",
  RCA_STUDIO_II: "rca-studio-ii",
  BALLY_ASTROCADE: "bally-astrocade",
  APF_MP_1000: "apf-mp-1000",
  COLECO_TELSTAR_ARCADE: "coleco-telstar-arcade",
  NINTENDO_SWITCH: "nintendo-switch",
  MILTON_BRADLEY_MICROVISION: "milton-bradley-microvision",
  ENTEX_SELECT_A_GAME: "entex-select-a-game",
  ENTEX_ADVENTURE_VISION: "entex-adventure-vision",
  PIONEER_LASERACTIVE: "",
  ACTION_MAX: "action-max",
  SHARP_X1: "sharp-x1",
  FUJITSU_FM_7: "fujitsu-fm-7",
  SAM_COUPE: "sam-coupe",
  SONY_PLAYSTATION_5: "sony-playstation-5",
  MICROSOFT_XBOX_SERIES_X: "microsoft-xbox-series-x",
  TANDY_VIS: "tandy-vis",
  R_ZONE: "r-zone",
  XAVIX_PORT: "xavix-port",
  EVERCADE: "evercade",
  ORIC_1: "oric-1",
  HYPERSCAN: "hyperscan",
  V_SMILE: "v-smile",
  MATTEL_AQUARIUS: "mattel-aquarius",
  OCULUS_QUEST: "oculus-quest",
  CASIO_LOOPY: "casio-loopy",
  GIZMONDO: "gizmondo",
  PHILIPS_TELE_SPIEL_ES_2201: "philips-tele-spiel-es-2201",
  INTERTON_VC_4000: "interton-vc-4000",
  BANDAI_TV_JACK_5000: "bandai-tv-jack-5000",
  SHG_BLACK_POINT: "shg-black-point",
  BBC_BRIDGE_COMPANION: "bbc-bridge-companion",
  VTECH_SOCRATES: "vtech-socrates",
  AMSTRAD_GX4000: "amstrad-gx4000",
  PLAYDIA: "playdia",
  APPLE_PIPPIN: "apple-pippin",
  GAME_WAVE: "game-wave",
  PALMTEX_SUPER_MICRO: "palmtex-super-micro",
  GAMATE: "gamate",
  VTECH_CREATIVISION: "vtech-creativision",
  COMMODORE_16: "commodore-16",
  COMMODORE_PLUS_4: "commodore-plus/4",
  COMMODORE_PET: "commodore-pet",
  SINCLAIR_ZX80: "sinclair-zx80",
  SINCLAIR_ZX81: "sinclair-zx81",
  STADIA: "stadia",
  DIDJ: "didj",
  BBC_MICRO: "bbc-micro",
  ACORN_ATOM: "acorn-atom",
  GP32: "gp32",
  PLAYDATE: "playdate",
  TAPWAVE_ZODIAC: "tapwave-zodiac",
  J2ME: "j2me",
  JUPITER_ACE: "jupiter-ace",
  SINCLAIR_QL: "sinclair-ql",
};

const PlatformDetails = {
  pc: { id: 1, name: "PC", alias: "pc" },
  "nintendo-gamecube": {
    id: 2,
    name: "Nintendo GameCube",
    alias: "nintendo-gamecube",
  },
  "nintendo-64": { id: 3, name: "Nintendo 64", alias: "nintendo-64" },
  "nintendo-gameboy": {
    id: 4,
    name: "Nintendo Game Boy",
    alias: "nintendo-gameboy",
  },
  "nintendo-gameboy-advance": {
    id: 5,
    name: "Nintendo Game Boy Advance",
    alias: "nintendo-gameboy-advance",
  },
  "super-nintendo-snes": {
    id: 6,
    name: "Super Nintendo (SNES)",
    alias: "super-nintendo-snes",
  },
  "nintendo-entertainment-system-nes": {
    id: 7,
    name: "Nintendo Entertainment System (NES)",
    alias: "nintendo-entertainment-system-nes",
  },
  "nintendo-ds": { id: 8, name: "Nintendo DS", alias: "nintendo-ds" },
  "nintendo-wii": { id: 9, name: "Nintendo Wii", alias: "nintendo-wii" },
  "sony-playstation": {
    id: 10,
    name: "Sony Playstation",
    alias: "sony-playstation",
  },
  "sony-playstation-2": {
    id: 11,
    name: "Sony Playstation 2",
    alias: "sony-playstation-2",
  },
  "sony-playstation-3": {
    id: 12,
    name: "Sony Playstation 3",
    alias: "sony-playstation-3",
  },
  "sony-psp": { id: 13, name: "Sony Playstation Portable", alias: "sony-psp" },
  "microsoft-xbox": { id: 14, name: "Microsoft Xbox", alias: "microsoft-xbox" },
  "microsoft-xbox-360": {
    id: 15,
    name: "Microsoft Xbox 360",
    alias: "microsoft-xbox-360",
  },
  "sega-dreamcast": { id: 16, name: "Sega Dreamcast", alias: "sega-dreamcast" },
  "sega-saturn": { id: 17, name: "Sega Saturn", alias: "sega-saturn" },
  "sega-genesis": { id: 18, name: "Sega Genesis", alias: "sega-genesis" },
  "sega-game-gear": { id: 20, name: "Sega Game Gear", alias: "sega-game-gear" },
  "sega-cd": { id: 21, name: "Sega CD", alias: "sega-cd" },
  "atari-2600": { id: 22, name: "Atari 2600", alias: "atari-2600" },
  arcade: { id: 23, name: "Arcade", alias: "arcade" },
  neogeo: { id: 24, name: "Neo Geo", alias: "neogeo" },
  "3do": { id: 25, name: "3DO", alias: "3do" },
  "atari-5200": { id: 26, name: "Atari 5200", alias: "atari-5200" },
  "atari-7800": { id: 27, name: "Atari 7800", alias: "atari-7800" },
  "atari-jaguar": { id: 28, name: "Atari Jaguar", alias: "atari-jaguar" },
  "atari-jaguar-cd": {
    id: 29,
    name: "Atari Jaguar CD",
    alias: "atari-jaguar-cd",
  },
  "atari-xe": { id: 30, name: "Atari XE", alias: "atari-xe" },
  colecovision: { id: 31, name: "Colecovision", alias: "colecovision" },
  intellivision: { id: 32, name: "Intellivision", alias: "intellivision" },
  "sega-32x": { id: 33, name: "Sega 32X", alias: "sega-32x" },
  "turbografx-16": { id: 34, name: "TurboGrafx 16", alias: "turbografx-16" },
  "sega-master-system": {
    id: 35,
    name: "Sega Master System",
    alias: "sega-master-system",
  },
  "sega-mega-drive": {
    id: 36,
    name: "Sega Mega Drive",
    alias: "sega-mega-drive",
  },
  "mac-os": { id: 37, name: "Mac OS", alias: "mac-os" },
  "nintendo-wii-u": { id: 38, name: "Nintendo Wii U", alias: "nintendo-wii-u" },
  "sony-playstation-vita": {
    id: 39,
    name: "Sony Playstation Vita",
    alias: "sony-playstation-vita",
  },
  "commodore-64": { id: 40, name: "Commodore 64", alias: "commodore-64" },
  "nintendo-gameboy-color": {
    id: 41,
    name: "Nintendo Game Boy Color",
    alias: "nintendo-gameboy-color",
  },
  amiga: { id: 4911, name: "Amiga", alias: "amiga" },
  "nintendo-3ds": { id: 4912, name: "Nintendo 3DS", alias: "nintendo-3ds" },
  "sinclair-zx-spectrum": {
    id: 4913,
    name: "Sinclair ZX Spectrum",
    alias: "sinclair-zx-spectrum",
  },
  "amstrad-cpc": { id: 4914, name: "Amstrad CPC", alias: "amstrad-cpc" },
  ios: { id: 4915, name: "iOS", alias: "ios" },
  android: { id: 4916, name: "Android", alias: "android" },
  "philips-cd-i": { id: 4917, name: "Philips CD-i", alias: "philips-cd-i" },
  "nintendo-virtual-boy": {
    id: 4918,
    name: "Nintendo Virtual Boy",
    alias: "nintendo-virtual-boy",
  },
  "sony-playstation-4": {
    id: 4919,
    name: "Sony Playstation 4",
    alias: "sony-playstation-4",
  },
  "microsoft-xbox-one": {
    id: 4920,
    name: "Microsoft Xbox One",
    alias: "microsoft-xbox-one",
  },
  ouya: { id: 4921, name: "Ouya", alias: "ouya" },
  "neo-geo-pocket": {
    id: 4922,
    name: "Neo Geo Pocket",
    alias: "neo-geo-pocket",
  },
  "neo-geo-pocket-color": {
    id: 4923,
    name: "Neo Geo Pocket Color",
    alias: "neo-geo-pocket-color",
  },
  "atari-lynx": { id: 4924, name: "Atari Lynx", alias: "atari-lynx" },
  wonderswan: { id: 4925, name: "WonderSwan", alias: "wonderswan" },
  "wonderswan-color": {
    id: 4926,
    name: "WonderSwan Color",
    alias: "wonderswan-color",
  },
  "magnavox-odyssey-2": {
    id: 4927,
    name: "Magnavox Odyssey 2",
    alias: "magnavox-odyssey-2",
  },
  fairchild: { id: 4928, name: "Fairchild Channel F", alias: "fairchild" },
  msx: { id: 4929, name: "MSX", alias: "msx" },
  pcfx: { id: 4930, name: "PC-FX", alias: "pcfx" },
  x68: { id: 4931, name: "Sharp X68000", alias: "x68" },
  fmtowns: { id: 4932, name: "FM Towns Marty", alias: "fmtowns" },
  pc88: { id: 4933, name: "PC-88", alias: "pc88" },
  pc98: { id: 4934, name: "PC-98", alias: "pc98" },
  nuon: { id: 4935, name: "Nuon", alias: "nuon" },
  fds: { id: 4936, name: "Famicom Disk System", alias: "fds" },
  "atari-st": { id: 4937, name: "Atari ST", alias: "atari-st" },
  ngage: { id: 4938, name: "N-Gage", alias: "ngage" },
  vectrex: { id: 4939, name: "Vectrex", alias: "vectrex" },
  "game-com": { id: 4940, name: "Game.com", alias: "game-com" },
  "trs80-color": {
    id: 4941,
    name: "TRS-80 Color Computer",
    alias: "trs80-color",
  },
  apple2: { id: 4942, name: "Apple II", alias: "apple2" },
  atari800: { id: 4943, name: "Atari 800", alias: "atari800" },
  "acorn-archimedes": {
    id: 4944,
    name: "Acorn Archimedes",
    alias: "acorn-archimedes",
  },
  "commodore-vic20": {
    id: 4945,
    name: "Commodore VIC-20",
    alias: "commodore-vic20",
  },
  c128: { id: 4946, name: "Commodore 128", alias: "c128" },
  "amiga-cd32": { id: 4947, name: "Amiga CD32", alias: "amiga-cd32" },
  megaduck: { id: 4948, name: "Mega Duck", alias: "megaduck" },
  sg1000: { id: 4949, name: "SEGA SG-1000", alias: "sg1000" },
  "game-and-watch": { id: 4950, name: "Game & Watch", alias: "game-and-watch" },
  lcd: { id: 4951, name: "Handheld Electronic Games (LCD)", alias: "lcd" },
  "dragon32-64": { id: 4952, name: "Dragon 32/64", alias: "dragon32-64" },
  "texas-instruments-ti-99-4a": {
    id: 4953,
    name: "Texas Instruments TI-99/4A",
    alias: "texas-instruments-ti-99-4a",
  },
  "acorn-electron": {
    id: 4954,
    name: "Acorn Electron",
    alias: "acorn-electron",
  },
  "turbo-grafx-cd": {
    id: 4955,
    name: "TurboGrafx CD",
    alias: "turbo-grafx-cd",
  },
  "neo-geo-cd": { id: 4956, name: "Neo Geo CD", alias: "neo-geo-cd" },
  "nintendo-pokmon-mini": {
    id: 4957,
    name: "Nintendo Pokémon Mini",
    alias: "nintendo-pokmon-mini",
  },
  "sega-pico": { id: 4958, name: "Sega Pico", alias: "sega-pico" },
  "watara-supervision": {
    id: 4959,
    name: "Watara Supervision",
    alias: "watara-supervision",
  },
  "tomy-pyta": { id: 4960, name: "Tomy Tutor", alias: "tomy-pyta" },
  "magnavox-odyssey": {
    id: 4961,
    name: "Magnavox Odyssey 1",
    alias: "magnavox-odyssey",
  },
  "gakken-compact-vision": {
    id: 4962,
    name: "Gakken Compact Vision",
    alias: "gakken-compact-vision",
  },
  "emerson-arcadia-2001": {
    id: 4963,
    name: "Emerson Arcadia 2001",
    alias: "emerson-arcadia-2001",
  },
  "casio-pv-1000": { id: 4964, name: "Casio PV-1000", alias: "casio-pv-1000" },
  "epoch-cassette-vision": {
    id: 4965,
    name: "Epoch Cassette Vision",
    alias: "epoch-cassette-vision",
  },
  "epoch-super-cassette-vision": {
    id: 4966,
    name: "Epoch Super Cassette Vision",
    alias: "epoch-super-cassette-vision",
  },
  "rca-studio-ii": { id: 4967, name: "RCA Studio II", alias: "rca-studio-ii" },
  "bally-astrocade": {
    id: 4968,
    name: "Bally Astrocade",
    alias: "bally-astrocade",
  },
  "apf-mp-1000": { id: 4969, name: "APF MP-1000", alias: "apf-mp-1000" },
  "coleco-telstar-arcade": {
    id: 4970,
    name: "Coleco Telstar Arcade",
    alias: "coleco-telstar-arcade",
  },
  "nintendo-switch": {
    id: 4971,
    name: "Nintendo Switch",
    alias: "nintendo-switch",
  },
  "milton-bradley-microvision": {
    id: 4972,
    name: "Milton Bradley Microvision",
    alias: "milton-bradley-microvision",
  },
  "entex-select-a-game": {
    id: 4973,
    name: "Entex Select-a-Game",
    alias: "entex-select-a-game",
  },
  "entex-adventure-vision": {
    id: 4974,
    name: "Entex Adventure Vision",
    alias: "entex-adventure-vision",
  },
  "": { id: 4975, name: "Pioneer LaserActive", alias: "" },
  "action-max": { id: 4976, name: "Action Max", alias: "action-max" },
  "sharp-x1": { id: 4977, name: "Sharp X1", alias: "sharp-x1" },
  "fujitsu-fm-7": { id: 4978, name: "Fujitsu FM-7", alias: "fujitsu-fm-7" },
  "sam-coupe": { id: 4979, name: "SAM Coupé", alias: "sam-coupe" },
  "sony-playstation-5": {
    id: 4980,
    name: "Sony Playstation 5",
    alias: "sony-playstation-5",
  },
  "microsoft-xbox-series-x": {
    id: 4981,
    name: "Microsoft Xbox Series X",
    alias: "microsoft-xbox-series-x",
  },
  "tandy-vis": {
    id: 4982,
    name: "Tandy Visual Interactive System",
    alias: "tandy-vis",
  },
  "r-zone": { id: 4983, name: "R-Zone", alias: "r-zone" },
  "xavix-port": { id: 4984, name: "Xavix Port", alias: "xavix-port" },
  evercade: { id: 4985, name: "Evercade", alias: "evercade" },
  "oric-1": { id: 4986, name: "Oric-1", alias: "oric-1" },
  hyperscan: { id: 4987, name: "HyperScan", alias: "hyperscan" },
  "v-smile": { id: 4988, name: "V.Smile", alias: "v-smile" },
  "mattel-aquarius": {
    id: 4989,
    name: "Mattel Aquarius",
    alias: "mattel-aquarius",
  },
  "oculus-quest": { id: 4990, name: "Oculus Quest", alias: "oculus-quest" },
  "casio-loopy": { id: 4991, name: "Casio Loopy", alias: "casio-loopy" },
  gizmondo: { id: 4992, name: "Gizmondo", alias: "gizmondo" },
  "philips-tele-spiel-es-2201": {
    id: 4993,
    name: "Philips Tele-Spiel ES-2201",
    alias: "philips-tele-spiel-es-2201",
  },
  "interton-vc-4000": {
    id: 4994,
    name: "Interton VC 4000",
    alias: "interton-vc-4000",
  },
  "bandai-tv-jack-5000": {
    id: 4995,
    name: "Bandai TV Jack 5000",
    alias: "bandai-tv-jack-5000",
  },
  "shg-black-point": {
    id: 4996,
    name: "SHG Black Point",
    alias: "shg-black-point",
  },
  "bbc-bridge-companion": {
    id: 4997,
    name: "BBC Bridge Companion",
    alias: "bbc-bridge-companion",
  },
  "vtech-socrates": {
    id: 4998,
    name: "VTech Socrates",
    alias: "vtech-socrates",
  },
  "amstrad-gx4000": {
    id: 4999,
    name: "Amstrad GX4000",
    alias: "amstrad-gx4000",
  },
  playdia: { id: 5000, name: "Playdia", alias: "playdia" },
  "apple-pippin": { id: 5001, name: "Apple Pippin", alias: "apple-pippin" },
  "game-wave": { id: 5002, name: "Game Wave", alias: "game-wave" },
  "palmtex-super-micro": {
    id: 5003,
    name: "Palmtex Super Micro",
    alias: "palmtex-super-micro",
  },
  gamate: { id: 5004, name: "Gamate", alias: "gamate" },
  "vtech-creativision": {
    id: 5005,
    name: "VTech CreatiVision",
    alias: "vtech-creativision",
  },
  "commodore-16": { id: 5006, name: "Commodore 16", alias: "commodore-16" },
  "commodore-plus/4": {
    id: 5007,
    name: "Commodore Plus/4",
    alias: "commodore-plus/4",
  },
  "commodore-pet": { id: 5008, name: "Commodore PET", alias: "commodore-pet" },
  "sinclair-zx80": { id: 5009, name: "Sinclair ZX80", alias: "sinclair-zx80" },
  "sinclair-zx81": { id: 5010, name: "Sinclair ZX81", alias: "sinclair-zx81" },
  stadia: { id: 5011, name: "Stadia", alias: "stadia" },
  didj: { id: 5012, name: "Didj", alias: "didj" },
  "bbc-micro": { id: 5013, name: "BBC Micro", alias: "bbc-micro" },
  "acorn-atom": { id: 5014, name: "Acorn Atom", alias: "acorn-atom" },
  gp32: { id: 5015, name: "GP32", alias: "gp32" },
  playdate: { id: 5016, name: "Playdate", alias: "playdate" },
  "tapwave-zodiac": {
    id: 5017,
    name: "Tapwave Zodiac",
    alias: "tapwave-zodiac",
  },
  j2me: {
    id: 5018,
    name: "J2ME (Java Platform, Micro Edition)",
    alias: "j2me",
  },
  "jupiter-ace": { id: 5019, name: "Jupiter Ace", alias: "jupiter-ace" },
  "sinclair-ql": { id: 5020, name: "Sinclair QL", alias: "sinclair-ql" },
};

function getPlatformById(id) {
  return Object.values(PlatformDetails).find((platform) => platform.id === id);
}

export { PlatformsEnum, PlatformDetails, getPlatformById };
